import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useEffect, useState } from "react";
import { StyledScrollTop } from "../../styled/commons";

/** Botón flotante "volver arriba", visible al scrollear. */
const ScrollTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <StyledScrollTop.Button
      visible={visible}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Volver arriba">
      <KeyboardArrowUpIcon />
    </StyledScrollTop.Button>
  );
};

export default ScrollTop;
